// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#navigation {
  padding-left: 0;
}

#flyoutHolder {
  align-items: baseline;
  position: relative;
  display: flex;
  float: left;
  margin-right: 50px;
  padding-bottom: 15px;
  width: 40px;
}

#hamburger {
  float: left;
  margin-right: 50px;
  position: relative;
  width: 40px;
  padding-bottom: 3px;
  padding-left: 10px;
  height: 100px;
  border: 3px;
  top: 64px;
}

#hamburger-lms {
  float: left;
  margin-right: 50px;
  position: relative;
  width: 40px;
  padding-bottom: 3px;
  /* padding-left: 10px;*/
  height: 100px;
  border: 3px;
  top: 64px;
}

#hamburger .messageCount {
  -webkit-border-radius: 15px;
  -moz-border-radius: 15px;
  background-color: #f00;
  border-radius: 15px;
  color: #fff;
  left: 30px;
  position: absolute;
  top: -10px;
  padding: 3px 7px;
}

.flyout {
  background-color: white;
  display: none;
  position: absolute;
  top: 103px;
  z-index: 106;
  left: 0;
  -webkit-box-shadow: 0px 2px 0.5px 0.7px rgba(51, 51, 51, 0.35);
  -moz-box-shadow: 0px 2px 0.5px 0.7px rgba(51, 51, 51, 0.35);
  box-shadow: 0px 2px 0.5px 0.7px rgba(51, 51, 51, 0.35);
}

.flyout .body {
  float: left;
  width: 215px;
}

.flyout .body ul {
  list-style: none;
  margin: 0px;
  padding: 0px;
}

.flyout .body ul li {
  border-bottom: 1px solid #313131;
  display: block;
}

.flyout .body ul li:last-child {
  border-bottom: none;
}

.flyout .body ul li:hover {
  border-bottom: 1px solid #313131;
  background: #e5e5e5;
  cursor: pointer;
}

.flyout .body ul li a {
  font-size: 14px;
  color: #333333;
  display: block;
  padding: 15px 2rem;
  width: 100%;
  text-decoration: none;
}

.messageCount {
  color: white;
  background: #3399cc;
  margin-left: 3px;
  font-size: 11px;
  font-weight: bold;
  -webkit-border-radius: 20px;
  -moz-border-radius: 20px;
  border-radius: 20px;
  padding-left: 6px;
  padding-right: 7px;
  padding-top: 3px;
  padding-bottom: 4px;
}

.flyout .body ul a:hover {
  /*border-bottom: 1px solid #1EABE3;*/
  /*text-decoration: none;
    color: #333333;
    background-color: #e5e5e5*/
}

.c-hamburger {
  background: none;
  display: block;
  position: relative;
  float: left;
  overflow: hidden;
  margin: 0;
  padding: 0;
  width: 60px;
  height: 27px;
  font-size: 0;
  text-indent: -9999px;
  appearance: none;
  box-shadow: none;
  border-radius: none;
  border: none;
  cursor: pointer;
}

.c-hamburger:focus {
  outline: none;
}

.c-hamburger span {
  display: block;
  position: absolute;
  top: 10px;
  left: 0;
  right: 26px;
  height: 4px;
  background-color: #1eabe3;
  border-radius: 3px;
}

.c-hamburger span::before,
.c-hamburger span::after {
  position: absolute;
  display: block;
  left: 0;
  width: 100%;
  height: 4px;
  background-color: #1eabe3;
  content: '';
  border-radius: 3px;
}

.c-hamburger span::before {
  top: -10px;
}

.c-hamburger span::after {
  bottom: -10px;
}

.c-hamburger--htla {
}

.c-hamburger--htla span {
}

.c-hamburger--htla span::before {
  transform-origin: top right;
}

.c-hamburger--htla span::after {
  transform-origin: bottom right;
}

/* active state, i.e. menu open */
.c-hamburger--htla.is-active .portalBackground {
  background-color: white !important;
}

/* make the X flush right with the hamburger */
.c-hamburger--htla.is-active {
  left: 7px;
}

.c-hamburger--htla.is-active span {
  transform: rotate(180deg);
}

/*
.c-hamburger--htla.is-active span::before,
.c-hamburger--htla.is-active span::after {
    width: 50%;
}
*/

.c-hamburger--htla.is-active span::before {
  top: 12px;
  transform: rotate(45deg);
}

.c-hamburger--htla.is-active span::after {
  bottom: 13px;
  transform: rotate(-45deg);
}

.c-hamburger--htla.is-active span::before,
.c-hamburger--htla.is-active span::after {
  height: 3px;
  width: 95%;
  border-radius: 5px;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/components/sidenav.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,SAAS;AACX;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,WAAW;EACX,SAAS;AACX;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,OAAO;EACP,8DAA8D;EAC9D,2DAA2D;EAC3D,sDAAsD;AACxD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC;;8BAE4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,cAAc;EACd,OAAO;EACP,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;AACA;;AAEA;AACA;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA,iCAAiC;AACjC;EACE,kCAAkC;AACpC;;AAEA,8CAA8C;AAC9C;EACE,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;;CAKC;;AAED;EACE,SAAS;EACT,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;EACX,UAAU;EACV,kBAAkB;AACpB","sourcesContent":["#navigation {\n  padding-left: 0;\n}\n\n#flyoutHolder {\n  align-items: baseline;\n  position: relative;\n  display: flex;\n  float: left;\n  margin-right: 50px;\n  padding-bottom: 15px;\n  width: 40px;\n}\n\n#hamburger {\n  float: left;\n  margin-right: 50px;\n  position: relative;\n  width: 40px;\n  padding-bottom: 3px;\n  padding-left: 10px;\n  height: 100px;\n  border: 3px;\n  top: 64px;\n}\n\n#hamburger-lms {\n  float: left;\n  margin-right: 50px;\n  position: relative;\n  width: 40px;\n  padding-bottom: 3px;\n  /* padding-left: 10px;*/\n  height: 100px;\n  border: 3px;\n  top: 64px;\n}\n\n#hamburger .messageCount {\n  -webkit-border-radius: 15px;\n  -moz-border-radius: 15px;\n  background-color: #f00;\n  border-radius: 15px;\n  color: #fff;\n  left: 30px;\n  position: absolute;\n  top: -10px;\n  padding: 3px 7px;\n}\n\n.flyout {\n  background-color: white;\n  display: none;\n  position: absolute;\n  top: 103px;\n  z-index: 106;\n  left: 0;\n  -webkit-box-shadow: 0px 2px 0.5px 0.7px rgba(51, 51, 51, 0.35);\n  -moz-box-shadow: 0px 2px 0.5px 0.7px rgba(51, 51, 51, 0.35);\n  box-shadow: 0px 2px 0.5px 0.7px rgba(51, 51, 51, 0.35);\n}\n\n.flyout .body {\n  float: left;\n  width: 215px;\n}\n\n.flyout .body ul {\n  list-style: none;\n  margin: 0px;\n  padding: 0px;\n}\n\n.flyout .body ul li {\n  border-bottom: 1px solid #313131;\n  display: block;\n}\n\n.flyout .body ul li:last-child {\n  border-bottom: none;\n}\n\n.flyout .body ul li:hover {\n  border-bottom: 1px solid #313131;\n  background: #e5e5e5;\n  cursor: pointer;\n}\n\n.flyout .body ul li a {\n  font-size: 14px;\n  color: #333333;\n  display: block;\n  padding: 15px 2rem;\n  width: 100%;\n  text-decoration: none;\n}\n\n.messageCount {\n  color: white;\n  background: #3399cc;\n  margin-left: 3px;\n  font-size: 11px;\n  font-weight: bold;\n  -webkit-border-radius: 20px;\n  -moz-border-radius: 20px;\n  border-radius: 20px;\n  padding-left: 6px;\n  padding-right: 7px;\n  padding-top: 3px;\n  padding-bottom: 4px;\n}\n\n.flyout .body ul a:hover {\n  /*border-bottom: 1px solid #1EABE3;*/\n  /*text-decoration: none;\n    color: #333333;\n    background-color: #e5e5e5*/\n}\n\n.c-hamburger {\n  background: none;\n  display: block;\n  position: relative;\n  float: left;\n  overflow: hidden;\n  margin: 0;\n  padding: 0;\n  width: 60px;\n  height: 27px;\n  font-size: 0;\n  text-indent: -9999px;\n  appearance: none;\n  box-shadow: none;\n  border-radius: none;\n  border: none;\n  cursor: pointer;\n}\n\n.c-hamburger:focus {\n  outline: none;\n}\n\n.c-hamburger span {\n  display: block;\n  position: absolute;\n  top: 10px;\n  left: 0;\n  right: 26px;\n  height: 4px;\n  background-color: #1eabe3;\n  border-radius: 3px;\n}\n\n.c-hamburger span::before,\n.c-hamburger span::after {\n  position: absolute;\n  display: block;\n  left: 0;\n  width: 100%;\n  height: 4px;\n  background-color: #1eabe3;\n  content: '';\n  border-radius: 3px;\n}\n\n.c-hamburger span::before {\n  top: -10px;\n}\n\n.c-hamburger span::after {\n  bottom: -10px;\n}\n\n.c-hamburger--htla {\n}\n\n.c-hamburger--htla span {\n}\n\n.c-hamburger--htla span::before {\n  transform-origin: top right;\n}\n\n.c-hamburger--htla span::after {\n  transform-origin: bottom right;\n}\n\n/* active state, i.e. menu open */\n.c-hamburger--htla.is-active .portalBackground {\n  background-color: white !important;\n}\n\n/* make the X flush right with the hamburger */\n.c-hamburger--htla.is-active {\n  left: 7px;\n}\n\n.c-hamburger--htla.is-active span {\n  transform: rotate(180deg);\n}\n\n/*\n.c-hamburger--htla.is-active span::before,\n.c-hamburger--htla.is-active span::after {\n    width: 50%;\n}\n*/\n\n.c-hamburger--htla.is-active span::before {\n  top: 12px;\n  transform: rotate(45deg);\n}\n\n.c-hamburger--htla.is-active span::after {\n  bottom: 13px;\n  transform: rotate(-45deg);\n}\n\n.c-hamburger--htla.is-active span::before,\n.c-hamburger--htla.is-active span::after {\n  height: 3px;\n  width: 95%;\n  border-radius: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
